import { render } from "./RoleCreate.vue?vue&type=template&id=372b9f42&scoped=true"
import script from "./RoleCreate.vue?vue&type=script&lang=js"
export * from "./RoleCreate.vue?vue&type=script&lang=js"

import "./RoleCreate.vue?vue&type=style&index=0&id=372b9f42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372b9f42"]])

export default __exports__